'use strict';

var coreUtilityAliases = require('../var/coreUtilityAliases');

var forEachProperty = coreUtilityAliases.forEachProperty;

function defineOnPrototype(ctor, methods) {
  var proto = ctor.prototype;
  forEachProperty(methods, function(val, key) {
    proto[key] = val;
  });
}

module.exports = defineOnPrototype;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/common/internal/defineOnPrototype.js
// module id = 16
// module chunks = 1